export const BUSINESS_PATHNAME = '/business';
export const POP_PATHNAME = '/product/rings';
export const WHY_OURA_PATHNAME = '/why-oura';
export const MEMBERSHIP = '/membership';
export const CONTACT_PATHNAME = '/contact';
